import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Cada vez que el pathname cambie, la página hará scroll hacia el top
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;